import { fetchAllIpoPages } from "./fetchAllIpoPages";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_IPO_SUBSCRIPTIONS } from "../../../config/api";

// Walks every page so the table and the allotment modal see all subscribers.
export const getIpoSubscriptions = createAsyncThunk(
  "ipos/getSubscriptions",
  async ({ id }, { rejectWithValue }) => {
    try {
      return await fetchAllIpoPages({
        path: API_IPO_SUBSCRIPTIONS(id),
        key: "subscriptions",
      });
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
